import { useRef, useState, useCallback, useEffect } from "react";
import Webcam from "react-webcam";

const Camera = ({ onCapture, capturedUrl }) => {
  const webcamRef = useRef(null)
  const [url, setUrl] = useState(null);

  const capturePhoto = useCallback(async () => {
    const imgSrc =  webcamRef.current.getScreenshot();
    setUrl(imgSrc)

    onCapture(imgSrc);
  }, [webcamRef, onCapture])


  useEffect(() => {
    setUrl(capturedUrl);
  }, [capturedUrl]);


  return (
    <div>
      <Webcam
        className={` rounded-lg ${url == null ? "" : "hidden"}`} 
        ref={webcamRef}
        audio={false}
        screenshotFormat="image/png"
        videoConstraints={{
          facingMode: "environment",
          width: 770,
          height: 1080
        }}
        forceScreenshotSourceSize={true}
      />
      <div className={`flex flex-col ${url == null ? "" : "hidden"}`}>
        <button type="button" className="mt-4 btn btn-secondary w-full text-lg text-base-100" onClick={capturePhoto}>TIRAR FOTO</button>
      </div>
      {url && (
        <div>
          <img className="rounded-lg" src={url} alt="Screenshot" />
          <button type="button" className="mt-4 btn btn-secondary w-full text-lg text-base-100" onClick={() => setUrl(null)}>Tirar nova foto</button>
        </div>
      )}
    </div>
  )
}

export default Camera